export const SIDEBAR_ANIMATION_TIME = 0.15;
